export const theme = {
    primaryColor: '#007bff',
    secondaryColor: '#6c757d',
    // Add more colors as needed
  };